import { MdClose } from 'react-icons/md';

export default function QRCodeModal({ qrCode, status, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-surface rounded-lg p-6 max-w-sm w-full mx-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-ink">Connetti WhatsApp</h3>
          <button onClick={onClose} className="text-muted hover:text-muted"><MdClose size={24} /></button>
        </div>

        {status === 'ready' ? (
          <div className="text-center py-8">
            <div className="w-12 h-12 bg-brand-50 rounded-full flex items-center justify-center mx-auto mb-3">
              <span className="text-brand-700 text-xl">&#10003;</span>
            </div>
            <p className="text-sm text-ink">WhatsApp connesso!</p>
          </div>
        ) : qrCode ? (
          <div className="text-center">
            <img src={qrCode} alt="QR Code" className="mx-auto w-64 h-64" />
            <p className="text-sm text-muted mt-3">Scansiona il QR code con WhatsApp</p>
          </div>
        ) : (
          <div className="text-center py-8">
            <div className="w-8 h-8 border-2 border-brand-600 border-t-transparent rounded-full animate-spin mx-auto mb-3" />
            <p className="text-sm text-muted">Generando QR code...</p>
          </div>
        )}
      </div>
    </div>
  );
}
